"use client";

import React from "react";
import { MessageCircle, CalendarCheck, ArrowRight, CircleCheck, Clock, ShieldCheck, Leaf } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TurnMoreDentalLeadsIntoBookedAppointmentsAutomatically() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223387" id="mehrwegbecher-für-nachhaltige-veranstaltungen" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32 min-h-[90vh] flex items-center">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/sustainable_festival_crowd_bg.png)] bg-cover bg-center opacity-10 grayscale" />
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background/95 to-background" />
      </div>

      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] flex items-center justify-center select-none overflow-hidden z-0">
        <span className="text-[25vw] font-bold font-default text-secondary tracking-tighter leading-none">
          ECO-SYSTEM
        </span>
      </div>
      
      {}
      <div className="absolute top-0 right-0 -translate-y-1/4 translate-x-1/4 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px] pointer-events-none z-0" />
      <div className="absolute bottom-0 left-0 translate-y-1/4 -translate-x-1/4 w-[600px] h-[600px] bg-secondary/5 rounded-full blur-[120px] pointer-events-none z-0" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={leftRef} className={`flex flex-col gap-8 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"} items-center text-center lg:items-start lg:text-left`}>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent text-accent-foreground text-xs font-bold uppercase tracking-wider border border-primary/10">
              <Leaf className="size-3.5 text-primary" />
              Regionaler Service in Kärnten
            </div>

            <div className="space-y-4">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold font-default tracking-tighter text-secondary leading-[0.95]">
                Mehrwegbecher für <br />
                <span className="text-primary">nachhaltige</span> <br />
                Events
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground leading-relaxed font-default max-w-xl">
                Mieten, Kaufen und Reinigen aus einer Hand. Wir unterstützen Veranstalter, Vereine und Gemeinden bei der Umstellung auf professionelle Mehrwegsysteme.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="h-14 px-10 text-base font-semibold shadow-xl shadow-primary/20 rounded-full bg-primary hover:bg-primary/90 transition-all group">
                <Link to="/ContactPage">
                  Jetzt Anfrage senden
                  <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              <Button asChild size="lg" variant="outline" className="h-14 px-10 text-base font-semibold border-border text-secondary hover:bg-accent hover:text-accent-foreground transition-colors rounded-full">
                <Link to="#">
                  Unsere Leistungen
                </Link>
              </Button>
            </div>

            <div className="grid grid-cols-2 gap-8 pt-4 w-full max-w-md">
              <div className="flex items-start gap-3">
                <div className="size-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <ShieldCheck className="size-5 text-primary" />
                </div>
                <div>
                  <p className="font-bold text-secondary text-sm">100% Nachhaltig</p>
                  <p className="text-xs text-muted-foreground">Zertifizierte Systeme</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="size-10 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                  <Clock className="size-5 text-primary" />
                </div>
                <div>
                  <p className="font-bold text-secondary text-sm">Express Service</p>
                  <p className="text-xs text-muted-foreground">Schnelle Abwicklung</p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`relative transition-all duration-1000 delay-300 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-20"}`}>
            {}
            <div className="absolute -inset-10 bg-gradient-to-tr from-primary/10 to-transparent rounded-full blur-3xl opacity-50" />
            
            <div className="relative z-10 bg-card/40 backdrop-blur-xl rounded-3xl shadow-3xl border border-white/20 overflow-hidden flex flex-col h-[580px] w-full max-w-[380px] mx-auto transform lg:rotate-3 hover:rotate-0 transition-transform duration-700">
              
              {}
              <div className="bg-secondary/95 backdrop-blur-md px-6 py-6 flex items-center gap-4 text-white shadow-lg">
                <div className="size-12 rounded-full bg-white p-2 flex items-center justify-center shrink-0 shadow-inner">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cup4us_logo_icon_v2.png" alt="Cup4us Logo" className="size-8 object-contain" />
                </div>
                <div>
                  <h3 className="font-default font-bold text-base tracking-tight">Cup4us Service Portal</h3>
                  <p className="text-[10px] uppercase tracking-widest text-white/60 flex items-center gap-1.5">
                    <span className="size-2 rounded-full bg-primary animate-pulse"></span> System Online
                  </p>
                </div>
              </div>

              {}
              <div className="flex-1 p-6 flex flex-col gap-6 overflow-hidden relative">
                <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1650013/img/cup_texture_pattern.png)] opacity-[0.03] pointer-events-none" />
                
                {}
                <div className="flex flex-col gap-2 w-[90%] animate-in fade-in slide-in-from-left-4 duration-700">
                  <div className="bg-white/80 backdrop-blur-sm border border-border/50 p-4 rounded-2xl rounded-tl-none shadow-sm">
                    <p className="text-xs font-bold text-primary mb-1">Veranstalter</p>
                    <p className="text-sm text-secondary/80 leading-relaxed">Wir benötigen 5.000 Mehrwegbecher für unser Festival am 15. August. Inklusive Reinigung bitte.</p>
                  </div>
                </div>

                {}
                <div className="flex flex-col gap-2 w-[90%] self-end animate-in fade-in slide-in-from-right-4 duration-700 delay-300">
                  <div className="bg-primary text-white p-4 rounded-2xl rounded-tr-none shadow-lg shadow-primary/20">
                    <div className="flex items-center gap-2 font-bold text-sm mb-2">
                      <CalendarCheck className="size-4" />
                      Termin Bestätigt
                    </div>
                    <p className="text-sm opacity-90 leading-relaxed">Verfügbarkeit geprüft. Wir haben die Kapazität für 5.000 Einheiten inkl. Logistik reserviert.</p>
                  </div>
                </div>

                {}
                <div className="mt-auto bg-white/90 backdrop-blur-md border border-primary/20 p-5 rounded-2xl shadow-xl animate-in zoom-in-95 duration-1000 delay-500">
                  <div className="flex justify-between items-center mb-4">
                    <span className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">Status-Update</span>
                    <span className="px-2 py-0.5 rounded-full bg-primary/10 text-primary text-[10px] font-bold">In Planung</span>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-secondary/60">Lieferung</span>
                      <span className="font-bold text-secondary">14. Aug, 10:00</span>
                    </div>
                    <div className="w-full bg-muted h-1.5 rounded-full overflow-hidden">
                      <div className="bg-primary h-full w-2/3 rounded-full" />
                    </div>
                  </div>
                </div>
              </div>

              {}
              <div className="bg-white/50 p-4 border-t border-border/50 flex items-center gap-3">
                <div className="flex-1 bg-white rounded-full h-11 px-5 flex items-center text-sm text-muted-foreground border border-border shadow-inner">
                  Nachricht an Support...
                </div>
                <div className="size-11 rounded-full bg-secondary flex items-center justify-center text-white shadow-lg shrink-0 hover:bg-primary transition-colors cursor-pointer">
                  <MessageCircle className="size-5" />
                </div>
              </div>
            </div>

            {}
            <div className="absolute -left-8 bottom-20 bg-white p-4 rounded-2xl shadow-2xl border border-border flex items-center gap-4 animate-bounce hidden md:flex z-20">
              <div className="size-10 rounded-full bg-primary/10 flex items-center justify-center text-primary">
                <CircleCheck className="size-6" />
              </div>
              <div>
                <p className="text-[10px] text-muted-foreground font-bold uppercase tracking-tighter">Auswirkung</p>
                <p className="text-sm font-bold text-secondary">-85% Plastikmüll</p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}